module.exports = __webpack_public_path__ + "img/storeHowToUse.76be85f8.jpg";